import axios from 'axios';
import ssoAuth from '../utils/ssoAuth';

const API = axios.create({
  baseURL: 'https://api.sxdidc.com',
});

// 在每个请求中自动附加token
API.interceptors.request.use((req) => {
  // 优先使用传统token，然后是SSO token
  const token = localStorage.getItem('token') || ssoAuth.getToken();
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// 添加响应拦截器处理单点登录
API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 处理401错误（包括被踢出的情况）
    if (error.response?.status === 401) {
      const errorMessage = error.response?.data?.message || '';
      
      // 检查是否是因为单点登录被踢出
      if (errorMessage.includes('账号已在其他设备登录') || 
          errorMessage.includes('登录已失效') ||
          errorMessage.includes('session_expired') ||
          errorMessage.includes('token_invalid') ||
          error.response?.data?.code === 'KICKED_OUT') {
        
        // 清除本地存储
        const clearLocalStorage = () => {
          localStorage.removeItem('token');
          localStorage.removeItem('role');
          localStorage.removeItem('accountType');
          localStorage.removeItem('permissions');
          localStorage.removeItem('parentUsername');
          // 同时清除SSO数据
          ssoAuth.clearStorage();
        };

        // 显示被踢出提示并跳转登录页
        const handleKickOut = () => {
          // 获取账号类型
          const accountType = localStorage.getItem('accountType') || 'main';
          
          clearLocalStorage();
          
          // 通知用户被踢出
          if (window.antd && window.antd.Modal) {
            window.antd.Modal.warning({
              title: '登录状态失效',
              content: errorMessage || '您的账号已在其他设备登录，请重新登录',
              okText: '重新登录',
              centered: true,
              onOk: () => {
                window.location.href = accountType === 'ram' ? '/ram-login' : '/login';
              }
            });
          } else {
            // 如果antd Modal不可用，使用原生alert
            alert(errorMessage || '您的账号已在其他设备登录，请重新登录');
            window.location.href = accountType === 'ram' ? '/ram-login' : '/login';
          }
        };

        // 延迟执行，避免与其他操作冲突
        setTimeout(handleKickOut, 100);
      } else {
        // 其他401错误，清除token并跳转登录页
        const accountType = localStorage.getItem('accountType') || 'main';
        
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('accountType');
        localStorage.removeItem('permissions');
        localStorage.removeItem('parentUsername');
        // 同时清除SSO数据
        ssoAuth.clearStorage();
        
        // 静默跳转，不显示额外提示
        setTimeout(() => {
          window.location.href = accountType === 'ram' ? '/ram-login' : '/login';
        }, 100);
      }
    }
    
    return Promise.reject(error);
  }
);

// 登出接口
export const logout = async () => {
  try {
    const response = await API.post('/api/auth/logout');
    return response.data;
  } catch (error) {
    // 即使登出接口失败，前端也要清理本地数据
    console.error('调用登出接口失败:', error);
    throw error;
  }
};

export default API;
